<script lang="ts" setup>
import logo from '@i/logo-full-white.svg'
import {useForm, usePage} from "@inertiajs/vue3";
import Button from "@/Components/Buttons/Button.vue";
import {mapErrors} from "@/utilities";
import {computed, inject, ref} from "vue";

const route = inject("route");

const form = useForm({
    email: '',
    type: 'newsletter_subscription',
})

const submitted = ref(false);

function submitForm() {
    form.post(route("public.forms.store"), {
        preserveScroll: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
        onSuccess: () => (submitted.value = true),
    });
}

const companyDetails = computed(() => usePage().props.company_details);

</script>

<template>
    <footer class="mt-auto bg-primary text-white">
        <div class="container py-15">
            <div class="flex-center w-full pb-10 lg:pb-20">
                <img
                    :src="logo"
                    alt="Logo"
                    class="size"
                >
            </div>

            <div class="grid gap-8 lg:grid-cols-4">
                <div
                    v-if="!submitted"
                    class="lg:col-span-2"
                >
                    Op de hoogte blijven?
                    <p class="font-normal">
                        Meld je aan voor onze nieuwsbrief
                    </p>
                    <div class="mt-4 flex flex-col gap-2 lg:flex-row lg:gap-4">
                        <FormKit
                            v-model="form.email"
                            :classes="{
                                outer: 'flex-1',
                                input: '$reset border-b bg-primary border-white px-0 py-0 leading-[16px] w-full',
                            }"
                            :errors="form.errors.email"
                            class="w-full"
                            placeholder="e-mail adres"
                        />
                        <Button
                            :form="form"
                            label="Aanmelden"
                            @click="submitForm"
                        />
                    </div>
                </div>
                <div v-else>
                    <p>Bedankt! We houden je op de hoogte!</p>
                </div>
                <div>
                    <p>
                        telefoon
                    </p>

                    <a
                        :href="'tel:' + companyDetails.phone_number"
                        class="font-normal"
                    >
                        {{ companyDetails.phone_number }}
                    </a>
                    <p class="mt-4">
                        e-mail
                    </p>
                    <a
                        :href="'mailto:' + companyDetails.email_address"
                        class="font-normal"
                    >
                        {{ companyDetails.email_address }}
                    </a>
                </div>
                <div>
                    <p>
                        volg ons
                    </p>

                    <a
                        :href="companyDetails.instagram"
                        class="font-normal"
                    >
                        <svg
                            fill="none"
                            height="16"
                            viewBox="0 0 16 16"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clip-path="url(#clip0_58_715)">
                                <path
                                    d="M8.00257 3.89604C5.73921 3.89604 3.90213 5.73477 3.90213 8.00017C3.90213 10.2656 5.73921 12.1043 8.00257 12.1043C10.2659 12.1043 12.103 10.2656 12.103 8.00017C12.103 5.73985 10.2761 3.90112 8.01779 3.89604C8.01779 3.89604 8.00764 3.89604 8.00257 3.89604ZM8.00257 10.6668C6.53088 10.6668 5.3383 9.47319 5.3383 8.00017C5.3383 6.52715 6.53088 5.3335 8.00257 5.3335C9.47426 5.3335 10.6668 6.52715 10.6668 8.00017C10.6668 9.47319 9.47426 10.6668 8.00257 10.6668ZM13.2245 3.72843C13.2245 4.25668 12.7983 4.68335 12.2705 4.68335C11.7427 4.68335 11.3164 4.25668 11.3164 3.72843C11.3164 3.20017 11.7427 2.7735 12.2705 2.7735C12.7983 2.7735 13.2245 3.20017 13.2245 3.72335V3.72843ZM15.9396 4.70366C15.9649 3.45922 15.5031 2.25541 14.6455 1.35128C13.7422 0.497949 12.5394 0.0357268 11.3012 0.0560442C9.98174 -0.0201463 6.0234 -0.0201463 4.70395 0.0560442C3.46062 0.0306474 2.2579 0.49287 1.35458 1.3462C0.502017 2.25033 0.0351355 3.45414 0.0605094 4.69858C-0.0156125 6.01922 -0.0156125 9.98112 0.0605094 11.3018C0.0351355 12.5462 0.496942 13.75 1.35458 14.6541C2.2579 15.5075 3.46062 15.9697 4.70395 15.9494C6.0234 16.0256 9.98174 16.0256 11.3012 15.9494C12.5445 15.9748 13.7472 15.5126 14.6506 14.6541C15.5031 13.75 15.9649 12.5462 15.9446 11.3018C16.0207 9.98112 16.0207 6.0243 15.9446 4.70366H15.9396ZM14.2344 12.7189C13.9604 13.4148 13.4072 13.9684 12.712 14.2427C11.6615 14.6592 9.15962 14.5627 7.99749 14.5627C6.83536 14.5627 4.33349 14.6541 3.28301 14.2427C2.58776 13.9684 2.03461 13.4148 1.76057 12.7189C1.34443 11.6675 1.44085 9.16335 1.44085 8.00017C1.44085 6.837 1.34951 4.33287 1.76057 3.28144C2.03461 2.58557 2.58776 2.03192 3.28301 1.75763C4.33349 1.34112 6.83536 1.43763 7.99749 1.43763C9.15962 1.43763 11.6615 1.3462 12.712 1.75763C13.4072 2.03192 13.9604 2.58557 14.2344 3.28144C14.6506 4.33287 14.5541 6.837 14.5541 8.00017C14.5541 9.16335 14.6506 11.6675 14.2344 12.7189Z"
                                    fill="#F2F2F2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_58_715">
                                    <rect
                                        fill="white"
                                        height="16"
                                        width="16"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </a>
                    <p class="mt-4">
                        adres
                    </p>
                    <p>
                        {{ companyDetails.street }} {{ companyDetails.street_number }} <br>
                        {{ companyDetails.postcode }} {{ companyDetails.city }}
                    </p>
                </div>
            </div>
        </div>
        <div class="container lg:pl-container lg:pr-container  flex-between px-4 py-3">
            <a href="https://strixi.nl/?utm_source=Developed+sites&utm_medium=Website&utm_campaign=Footer">Puur catering
                2024, gemaakt door STRIXI
            </a>
            <a href="https://puur-catering.strixi.nl/privacy-verklaring">
                Privacy verklaring
            </a>
        </div>
    </footer>
</template>

<style scoped>

</style>
